module.exports = __webpack_public_path__ + "img/sun.b78bb270.svg";